import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toThunkRejectValue } from "../../../Common/isRequestCanceled";
import {
  BASE_URL,
  LIST_ALL_CATEGORIES,
  DELETE_SINGLE_CATEGORIE,
  CATEGORIE_STATUS,
  CATEGORIE_BANNER_REMOVE,
  ELASTIC_SEARCH_BASE_URL,
} from "../../../Constants/Config";
import { ciBase } from "../../../Constants/nodeCi";

const initialState = {
  loading: false,
  categoriesData: [],
  successMessage: "",
  error: "",
};

// Only the latest in-flight list request survives — cancel the previous one
// so a slow earlier response can't overwrite newer data.
let cancelCategoriesSource;

// Generate pening , fulfilled and rejected action type
// export const fetchCategoriesData = createAsyncThunk('categories/fetchCategoriesData', async (data) => {
//     let dataNew={merchant_id:data?.merchant_id,login_type:data?.login_type,token_id:data?.token_id}
//     let token={token:data?.token}
//     console.log(token)

//     // console.log('hhhhh')
//     try {
//         const response = await axios.post(BASE_URL + LIST_ALL_CATEGORIES, dataNew, {
//             headers: {
//               "Content-Type": "multipart/form-data",
//               'Authorization': `${data?.token}`
//             }
//           });
//         if (response.status === 200) {
//             // console.log(response.data)
//            return response.data.result
//         }
//     } catch (error) {
//         throw new Error(error.response.data.message);
//     }
// })

export const fetchCategoriesData = createAsyncThunk(
  "categories/fetchCategoriesData",
  async (data, { getState, rejectWithValue }) => {
    // Cancel the previous in-flight request before firing a new one.
    if (cancelCategoriesSource) {
      cancelCategoriesSource.cancel("Previous request canceled");
    }
    cancelCategoriesSource = axios.CancelToken.source();
    const { token, ...dataNew } = data;
    try {
      // Hit elastic only when it's on AND reachable. `isElasticConnected` is set
      // once at load time by the CheckElasticConnection thunk (dispatched from
      // SideMenu); it is false when elastic is off or unreachable, so we fall
      // back to BASE_URL. Mirrors Product/ProductSlice.js and purchaseOrdersApi.js.
      const isElasticConnected = getState().permissions.isElasticConnected;
      let baseurl = isElasticConnected ? ELASTIC_SEARCH_BASE_URL : ciBase(LIST_ALL_CATEGORIES);

      const response = await axios.post(
        baseurl + LIST_ALL_CATEGORIES,
        dataNew,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`, // Use data?.token directly
          },
          cancelToken: cancelCategoriesSource.token,
        }
      );

      if (response.status === 200) {
        return response.data.result;
      }
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ cancelled: true });
      }
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

// Generate pening , fulfilled and rejected action type

/* export const addToWishlist = createAsyncThunk('wishlist/addToWishlist', async (data) => {
    try {
        const response = await axios.post(BASE_URL + ADD_TO_WISHLIST, data, {
            headers: { "Content-Type": "multipart/form-data" }
        });
        if(response.data.status === 200) {
            return response.data.message;
        }
    } catch (error) {
        throw new Error(error.response.data.message);
    }
});


*/
export const deleteCategory = createAsyncThunk(
  "categories/deleteCategory",
  async (data, { rejectWithValue }) => {
    try {
      const { token, ...dataNew } = data;
      const response = await axios.post(
        BASE_URL + DELETE_SINGLE_CATEGORIE,
        dataNew,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response) {
        // console.log(response);
        return {
          categoryId: data.id,
        };
      }
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

// for deleteBanner image
export const deleteCategorybanner = createAsyncThunk(
  "categories/deleteCategorybanner",
  async (data) => {
    try {
      const { token, ...dataNew } = data;
      const response = await axios.post(
        BASE_URL + CATEGORIE_BANNER_REMOVE,
        dataNew,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response) {
        // console.log(response);
        return {
          categoryId: data.id,
        };
      }
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

//  updating category status
export const updateCategoryStatus = createAsyncThunk(
  "categories/updateCategoryStatus",
  async (data, { rejectWithValue }) => {
    try {
      const { token, ...dataNew } = data;
      const response = await axios.post(BASE_URL + CATEGORIE_STATUS, dataNew, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

const categoriesSlice = createSlice({
  name: "categories",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchCategoriesData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchCategoriesData.fulfilled, (state, action) => {
      state.loading = false;
      state.categoriesData = action.payload;
      state.error = "";
    });
    builder.addCase(fetchCategoriesData.rejected, (state, action) => {
      // Superseded by a newer request — leave state to that newer request.
      if (action.payload?.cancelled) return;
      state.loading = false;
      state.categoriesData = {};
      state.error = action.error.message;
    });

    /* builder.addCase(addToWishlist.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(addToWishlist.fulfilled, (state, action) => {
            state.loading = false;
            state.successMessage = action.payload;
            state.error = ''; // Reset the error message
        });
        builder.addCase(addToWishlist.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
*/

    builder.addCase(deleteCategory.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteCategory.fulfilled, (state, action) => {
      state.loading = false;
      state.successMessage = action?.payload?.message;
      state.categoriesData = state.categoriesData.filter(
        (item) => item && item.id !== action.payload.categoryId
      );

      state.error = ""; // Reset the error message
    });
    builder.addCase(deleteCategory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });

    // for deleteCategorybanner
    builder.addCase(deleteCategorybanner.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteCategorybanner.fulfilled, (state, action) => {
      state.loading = false;
      state.successMessage = action?.payload?.message;
      state.categoriesData = state.categoriesData.filter(
        (item) => item && item.id !== action.payload.categoryId
      );

      state.error = ""; // Reset the error message
    });
    builder.addCase(deleteCategorybanner.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
  },
});

export default categoriesSlice.reducer;
